import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { dashboardNavs } from "../navigationSidepanel";
import { useAuth } from "../auth/AuthProvider";

interface NavItem {
  title: string;
  path?: string;
  subModuleKey?: string;
  children?: NavItem[];
}

export const useModuleRedirect = (moduleKey: keyof typeof dashboardNavs) => {
  const { user, roleData } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    
    const permissions = roleData?.permissions || {};
    const isAdmin =
      user?.roles.includes("orgadmin") || user?.roles.includes("superadmin");

    const navItems: NavItem[] = dashboardNavs[moduleKey] || [];

    const findFirstAccessible = (items: NavItem[]): NavItem | undefined => {
      for (const item of items) {
        // If item has a direct path and access, return it
        if (item.path) {
          if (isAdmin) return item;
          if (item.subModuleKey) {
            const subPerms: any = permissions[item.subModuleKey];
            const hasRead = Array.isArray(subPerms)
              ? subPerms.includes("read")
              : subPerms instanceof Set
              ? subPerms.has("read")
              : false;
            if (hasRead) return item;
          }
        }
        // Check children recursively
        if (item.children) {
          const child = findFirstAccessible(item.children);
          if (child) return child;
        }
        // If no path but has children, continue to next item
        if (!item.path && !item.children) {
          continue;
        }
      }
      return undefined;
    };

    const firstAccessible = findFirstAccessible(navItems);

    if (firstAccessible?.path) {
      navigate(firstAccessible.path, { replace: true });
    } else {
      navigate("/unauthorized", { replace: true });
    }
  }, [moduleKey]);
};
